/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import { List } from "carbon-addons-iot-react";
import React, { Component } from 'react';
import {AppMsg} from '../utils';
import "./Sitemap.scss";

const FROM_SITEMAP = true;

class Sitemap extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sitemapMenuItemIds: []
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sitemapMenuItemIdsToDisplay !== this.props.sitemapMenuItemIdsToDisplay) {
      this.setState({
        sitemapMenuItemIds: this.props.sitemapMenuItemIdsToDisplay
      });
    }
  }

  _selectSitemapMenuItem(id) {
    //First handle href reset needed for open new window / new tab logic.
    this.props.handleListItemHrefReset(id, FROM_SITEMAP);
    this.props.sitemapMenuItemButtonClick(id);
  }

  _toggleSitemapMenuItem(id) {
    if (this.state.sitemapMenuItemIds.filter(rowId => rowId === id).length > 0) {
      this.setState({
        sitemapMenuItemIds: this.state.sitemapMenuItemIds.filter(rowId => rowId !== id)
      });
    } else {
      this.setState({
        sitemapMenuItemIds: this.state.sitemapMenuItemIds.concat([id])
      });
    }
  }
  
  render() {
    return (
        <div style={{ width: '100%' }}>
      <List
            className="sitemapList"
            hasMultiSelect={false}
            hasPagination={false}  
            hasSearch
            i18n={{
              close: AppMsg.getMessage("CLOSE"),
              expand: AppMsg.getMessage("EXPAND"),
              searchPlaceHolderText: AppMsg.getMessage(AppMsg.PROJ_SEARCH)
            }}
            isFullHeight={false}
            isLoading={false}
            items={this.props.sitemapMenuItemsToDisplay}
            handleSelect={(id) => {this._selectSitemapMenuItem(id)}}
            title={this.props.currentSelectedMenuItemLabel}
            expandedIds={this.state.sitemapMenuItemIds}
            toggleExpansion={(id) => {
              this._toggleSitemapMenuItem(id);
            }}
        />
    </div>
    );
  }
}

export default Sitemap;